import styled from "styled-components";
import { Box } from "rebass/styled-components";
import themeGet from "@styled-system/theme-get";

const TableStyle = styled(Box)`
  table-layout: fixed;
  text-align: left;
  border-collapse: collapse;
  width: 100%;

  &.striped tbody tr:nth-child(2n + 1) {
    background: #e5e5e5;
  }
  &.striped th,
  &.striped td {
    border: none;
  }

  th,
  td {
    padding: 1rem;
    border: 1px solid #e5e5e5;
  }

  .highlight {
    position: relative;
    color: ${themeGet("colors.primary")};

    &::before {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      width: 2px;
      background: ${themeGet("colors.primary")};
    }
  }
`;

const Table = ({ children, ...props }) => (
  <TableStyle as="table" {...props}>
    {children}
  </TableStyle>
);

export default Table;
